import {
  apiBaseUrl
} from 'yxt-biz-pc/packages/api';

/**
 * 获取用户列表
 * @param query
 * @return {*}
 */
export const getUserList = (data, params) => {
  data = data === undefined ? {} : data;
  return apiBaseUrl.post('/sptalentrv/udp/user/search', data, {
    params: params
  });
};
